module.exports = __webpack_public_path__ + "img/toubu.9397bb92.png";